import { canManageAiTokens, copyTextToClipboard, escapeHtml, getAiTokenShareUrl, getSpaceViewBaseUrl } from "../../../helpers/aiToken";

export class AiTokensModal {
  constructor({ model }) {
    this.model = model;
    this.wrapper = $("#show-ai-tokens");
    this.icon = $("#show-space-info-ai-tokens");
    this.tokens = [];
    this.bindEvents();
    this.syncIcon();
  }

  bindEvents() {
    this.icon.on("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      $("#show-space-info").removeClass("is-active");
      this.show();
    });
    this.wrapper.find("#close-ai-tokens, .modal-background").on("click", () => this.hide());
    this.wrapper.find("#ai_tokens_modal_default_link_copy").on("click", () => {
      this.copyLink($("#ai_tokens_modal_default_link").val());
    });
    this.wrapper.on("click", ".ai-token-copy-link", (e) => {
      e.preventDefault();
      const token = $(e.currentTarget).closest(".ai-token-item").data("token");
      this.copyLink(getAiTokenShareUrl(token));
    });
    this.wrapper.on("click", ".ai-token-report", (e) => {
      e.preventDefault();
      const token = $(e.currentTarget).closest(".ai-token-item").data("token");
      this.showReport(token);
    });
    this.wrapper.on("click", ".ai-tokens-report-back", () => this.showList());
    $(document).on("keydown.aiTokensModal", (e) => {
      if (e.key === "Escape" && this.isVisible()) this.hide();
    });
  }

  syncIcon() {
    const show = canManageAiTokens(this.model) && !this.model?.editMode;
    this.icon.toggle(!!show);
    this.icon.attr("title", $trans("ai-tokens-list") || "AI tokens");
  }

  show() {
    this.syncIcon();
    if (!canManageAiTokens(this.model)) return;
    this.showList();
    this.wrapper.addClass("is-active");
    this.loadTokens();
  }

  hide() {
    this.wrapper.removeClass("is-active");
  }

  isVisible() {
    return this.wrapper.hasClass("is-active");
  }

  copyLink(url) {
    copyTextToClipboard(url).then(() => {
      this.model.alert?.("success", $trans("link-copied") || "Copied to clipboard");
    }).catch(() => {
      this.model.alert?.("error", $trans("copy-failed") || "Could not copy link");
    });
  }

  worldId() {
    return this.model?.config?.worldId || this.model?.worldID;
  }

  loadTokens() {
    const worldId = this.worldId();
    const $list = this.wrapper.find("#ai_tokens_modal_list");
    $("#ai_tokens_modal_default_link").val(getSpaceViewBaseUrl());
    if (!worldId) {
      $list.html(`<div class="ai-tokens-empty caption_regular">${$trans("no-ai-tokens-text") || "No AI tokens yet."}</div>`);
      return;
    }
    this.model.worldFetcher.listVapiAiTokens(
      worldId,
      (res) => {
        this.tokens = res?.tokens || [];
        this.renderList();
      },
      () => {
        $list.html(`<div class="ai-tokens-empty caption_regular">${$trans("no-ai-tokens-text") || "No AI tokens yet."}</div>`);
      }
    );
  }

  showList() {
    this.wrapper.find(".ai-tokens-modal-list-view").show();
    this.wrapper.find(".ai-tokens-modal-report-view").hide();
  }

  renderList() {
    const $list = this.wrapper.find("#ai_tokens_modal_list");
    if (!this.tokens.length) {
      $list.html(`<div class="ai-tokens-empty caption_regular">${$trans("no-ai-tokens-text") || "No AI tokens yet."}</div>`);
      return;
    }
    $list.empty();
    this.tokens.forEach((row) => {
      const name = escapeHtml(row.name || row.token || "");
      const token = escapeHtml(row.token || "");
      const calls = Number(row.call_count || 0);
      $list.append(`
        <div class="ai-token-item flx-sb" data-token="${token}">
          <div class="ai-token-meta">
            <span class="ai-token-name">${name}</span>
            <span class="ai-token-code caption_regular">${token}</span>
          </div>
          <span class="ai-token-calls caption_regular">${calls} ${$trans("ai-token-calls") || "calls"}</span>
          <div class="ai-token-actions">
            <span class="ai-token-copy-link material-icons-outlined md-18" title="${$trans("ai-token-copy-link") || "Copy link"}">link</span>
            <span class="ai-token-report material-icons-outlined md-18" title="${$trans("ai-token-viewer-report") || "Report on viewer"}">analytics</span>
          </div>
        </div>
      `);
    });
  }

  showReport(token) {
    const row = this.tokens.find((t) => String(t.token) === String(token));
    this.wrapper.find(".ai-tokens-report-title").text(
      ($trans("ai-token-viewer-report") || "Report on viewer") + (row?.name ? `: ${row.name}` : "")
    );
    this.wrapper.find(".ai-tokens-modal-list-view").hide();
    this.wrapper.find(".ai-tokens-modal-report-view").show();
    const $report = this.wrapper.find("#ai_tokens_modal_report");
    $report.html(`<div class="ai-tokens-empty caption_regular">${$trans("loading-text") || "Loading…"}</div>`);
    this.model.worldFetcher.reportVapiAiToken(
      this.worldId(),
      token,
      (res) => this.renderReport(res),
      () => {
        $report.html(`<div class="ai-tokens-empty caption_regular">${$trans("ai-token-report-empty") || "No viewer calls yet."}</div>`);
      }
    );
  }

  renderReport(res) {
    const $report = this.wrapper.find("#ai_tokens_modal_report");
    const viewers = res?.viewers || [];
    const callCount = res?.token?.call_count ?? viewers.length;
    if (!viewers.length) {
      $report.html(`
        <div class="ai-tokens-report-summary caption_regular">${callCount} ${$trans("ai-token-calls") || "calls"}</div>
        <div class="ai-tokens-empty caption_regular">${$trans("ai-token-report-empty") || "No viewer calls yet."}</div>
      `);
      return;
    }
    const rows = viewers.map((v) => {
      const when = escapeHtml(v.started_at || v.created_at || "—");
      const viewer = escapeHtml(v.viewer || "Guest");
      const duration = escapeHtml(v.duration || "—");
      return `<div class="ai-token-report-row">
        <span class="ai-token-report-viewer">${viewer}</span>
        <span class="ai-token-report-time caption_regular">${when}</span>
        <span class="ai-token-report-duration caption_regular">${duration}</span>
      </div>`;
    }).join("");
    $report.html(`
      <div class="ai-tokens-report-summary caption_regular">${callCount} ${$trans("ai-token-calls") || "calls"}</div>
      <div class="ai-token-report-list">${rows}</div>
    `);
  }
}
